﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import View_SchemaScreen from '../../info/module/setting/schemaScreen';

import tpl_customSchemaSetting from './tpl/customSchemaSetting.html';

import language from '../../../common/language';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';
import * as Entities_Memory from '../../entities/memory';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';

import config from '../../../common/config';
import Help from '../../helper/help';
import View_Render from '../render/render';

import View_CustomHeader from '../region/customHeader/customHeader';

import * as Entities_Memory_Position from '../../entities/memoryPosition';

export default View_LayoutError.extend({
    designRegion: '#designRegion_modal',
    getTemplate: function () {
        if (this.options.designMode) {
            return tpl_customSchemaSettingDesign({ model: this.model.toJSON() });
        } else {
            return tpl_customSchemaSetting({ model: this.model.toJSON() });
        }
    },
    regions: {
        information: "#customSchemaSettingInformation",
        customHeader: "#customHeader"
    },
    onBeforeShow: function () {
        this.information.show(new View_Information({ collection: this.informationCollection, app: this.app }));

        var customHeaderModel = new Entities_Empty.Model();

        if (this.model) {
            customHeaderModel.attributes.Name = this.model.attributes.Name;
        } else {
            customHeaderModel.attributes.Name = "";
        }

        customHeaderModel.attributes.Title = resources.X101260;
        customHeaderModel.attributes.ShowSave = true;
        customHeaderModel.attributes.ShowBack = true;

        this.customHeader.show(new View_CustomHeader({ app: this.app, model: customHeaderModel }));
    },
    initialize: function () {
        var self = this;

        this.app = this.options.app;

        this.informationCollection = new Entities_Empty.Collection();

        this.listenTo(this.collection, 'add', this.updateInformationCollection, this);
        this.listenTo(this.collection, 'remove', this.updateInformationCollection, this);

        this.localSetting = new Entities_Empty.Model();
        this.localSetting.attributes.EventId = -1;

        this.setHasChanged(false);
        this.oldModel = this.model.clone();

        var userChannel = Backbone.Radio.channel('app');
        this.listenTo(userChannel, 'customHeader:iconSave', function () {
            self.btnSubmitClick(null);
        });
        this.listenTo(userChannel, 'customHeader:iconBack', function () {
            self.customSchemaSetting_btnBack_click();
        });	
    },
    signalR_init: function () {
        //this.IWannaChat = $.connection.Events4usHub;
        //$.connection.hub.start();
    },
    help: function () {
        Help.help(this, true, 'customSchemaLive');
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        this.save(callback);
    },
    cancelHasChanged: function () {
        this.model.attributes = this.oldModel.attributes;
    },
    modelHasChanged: function () {
        var changes = false;

        if (this.model) {
            this.setModel();

            if (this.model.attributes.SchemaMenuName != this.oldModel.attributes.SchemaMenuName) {
                changes = true;
            }
        }

        this.setHasChanged(changes);
    },
    ui: {
        'customSchemaSettingInformation': '#customSchemaSettingInformation',
        'customSchemaSetting_div_anySchema': '#customSchemaSetting_div_anySchema',
        'customSchemaSetting_inputNameGroup': '#customSchemaSetting_inputNameGroup',
        'customSchemaSetting_selectEvent': '#customSchemaSetting_selectEvent',
        'customSchemaSetting_divSchemaMenuName': '#customSchemaSetting_divSchemaMenuName',
        'customSchemaSetting_inputSchemaMenuName': '#customSchemaSetting_inputSchemaMenuName',
        'help': '#help',
        'designRegion_body': '#designRegion_body',
        'designRegion_btnOk': '#designRegion_btnOk',
        'customSchemaSetting_inputNameGroup': '#customSchemaSetting_inputNameGroup',
        'customSchemaSetting_btnSubmit': '#customSchemaSetting_btnSubmit',
        'customSchemaSetting_btnBack': '#customSchemaSetting_btnBack',
        'customSchemaSetting_btnDisplay': '#customSchemaSetting_btnDisplay'
    },
    events: {
        'click @ui.customSchemaSetting_btnSubmit': 'btnSubmitClick',
        'click #help': 'help',
        'click @ui.designRegion_btnOk': 'designRegion_btnOk',
        'click @ui.customSchemaSetting_btnBack	': 'customSchemaSetting_btnBack_click',
        'click @ui.customSchemaSetting_btnDisplay': 'customSchemaSetting_btnDisplay_click'
    },
    onRender: function () {
        this.setupEvent();
        this.renderInformation();

        if (this.app.mode == 1) {
            this.ui.customSchemaSetting_btnSubmit.css('display', 'none');
            this.ui.customSchemaSetting_btnBack.css('display', 'none');
        }

        return this;
    },
    renderInformation: function () {
        this.informationCollection.reset();

        this.app.renderInformation({ informationCollection: this.informationCollection });
    },
    updateInformationCollection: function () {
        this.renderInformation();
        this.informationCollection.trigger('change');
    },
    customViewEvent_setActive: function () {
        var array = [];

        if (this.localSetting.attributes.EventId != -1) {
            var tmp = { "id": this.localSetting.attributes.EventId };
            array.push(tmp);
        }

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('customViewEvent:setActive', array);
    },
    onAttach() {
        this.customViewEvent_setActive();

        if (this.options.designMode) {
            var height = $(window).height() * 0.8;
            this.ui.designRegion_body.height(height);
        }
    },
    setupEvent: function () {
    },
    setModel: function () {
        this.model.set({
            SchemaMenuName: this.ui.customSchemaSetting_inputSchemaMenuName.val(),
        }, { silent: true });
    },
    save: function (callbackRouter) {
        var self = this;

        var dialogWaitingModel = new Entities_Empty.Model();
        dialogWaitingModel.attributes.Title = resources.X100408;
        dialogWaitingModel.attributes.Text = resources.X100409;
        dialogWaitingModel.attributes.Button = resources.X100279;

        var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
        var callback = function (options) {
            self.stopListening(dialogWaiting, "dialog:okclicked", callback);
        }
        this.listenTo(dialogWaiting, "dialog:okclicked", callback);
        this.app.dialogRegion.show(dialogWaiting);

        this.setModel(this.model);

        var customModule = self.app.entities.collections.customModule.where({ EventId: this.options.eventId, ModuleType: 100 })[0];
        var data = JSON.parse(customModule.attributes.Data);
        var customModule_data = new Entities_Memory.Model(data[0].Data);

        customModule_data.attributes.SchemaScreen = this.model.toJSON();
        var strJson = JSON.stringify(customModule_data.toJSON());
        customModule.attributes.Data = '[{ "Data" : ' + strJson + '}]';

        customModule.save(customModule.attribute, {
            silent: false,
            wait: true,
            success: function () {
                dialogWaiting.triggerMethod('dialog:close');

                var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: self.options.eventId });
                if (customEvent && customEvent.length > 0) {
                    var render = new View_Render({ collection: customEvent, app: self.app });
                    var message = 'EVENT_REFRESH';
                    //render.pushMessage(self.options.eventId, message);
                    //callbackRouter();
                    render.doIt(callbackRouter, true, 'EVENT_REFRESH', false);
                }
            }
        });

        /*this.model.save(this.model.attributes, {
            silent: true,
            wait: true,
            success: function () {
                dialogWaiting.triggerMethod('dialog:close');
                self.oldModel = self.model.clone();

                var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ FormModel: self.model.attributes.id })
                var render = new View_Render({ collection: customEvent, app: self.app });
                self.app.renderRegion.show(render);
                var renderFinishCallback = function (options) {
                    if (callbackRouter) {
                        callbackRouter();
                    }
                }
                render.doIt(renderFinishCallback, false, 'EVENT_REFRESH', false);
            }
        });*/
    },
    btnSubmitClick: function (event) {
        if (event) {
            event.preventDefault();
        }

        var self = this;

        this.setModel(this.model);
        this.oldModel = this.model.clone();

        //this.model.validateNoBackbone(app, false, function (ret) {
        //    var modelErrors = ret;
        //    if (modelErrors) {
        //        self.hideErrors();
        //        self.showErrors(self.model.errors);
        //    }
        //    else {
        //        self.hideErrors();

                var dialogWaitingModel = new Entities_Empty.Model();
                dialogWaitingModel.attributes.Title = resources.X100408;
                dialogWaitingModel.attributes.Text = resources.X100181;
                dialogWaitingModel.attributes.Button = resources.X100279;

                var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });
                var callback = function (options) {
                    self.stopListening(dialogWaiting, "dialog:okclicked", callback);
                }
                self.listenTo(dialogWaiting, "dialog:okclicked", callback);
                self.app.dialogRegion.show(dialogWaiting);

                var customModule = self.app.entities.collections.customModule.where({ EventId: this.options.eventId, ModuleType: 100 })[0];
                var data = JSON.parse(customModule.attributes.Data);
                var customModule_data = new Entities_Memory.Model(data[0].Data);

                customModule_data.attributes.SchemaScreen = this.model.toJSON();
                var strJson = JSON.stringify(customModule_data.toJSON());
                customModule.attributes.Data = '[{ "Data" : ' + strJson + '}]';

                customModule.save(customModule.attribute, {
                    silent: false,
                    wait: true,
                    success: function () {
                        dialogWaiting.triggerMethod('dialog:close');

                        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: self.options.eventId });
                        if (customEvent && customEvent.length > 0) {
                            var render = new View_Render({ collection: customEvent, app: self.app });
                            //var message = 'EVENT_REFRESH';
                            //render.pushMessage(self.options.eventId, message);
                            var callbackRouter = function (options) {
                            }
                            render.doIt(callbackRouter, true, 'EVENT_REFRESH', false);
                        }
                    }
                });

                
                /*
                self.model.save(self.model.attributes, {
                    silent: true,
                    wait: true,
                    success: function () {
                        dialogWaiting.triggerMethod('dialog:close');
                        self.oldModel = self.model.clone();

                        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ FormModel: self.model.attributes.id })
                        var render = new View_Render({ collection: customEvent, app: self.app });
                        self.app.renderRegion.show(render);
                        var renderFinishCallback = function (options) {
                        }
                        render.doIt(renderFinishCallback, false, 'EVENT_REFRESH', false);
                    }
                });
                */
            //}
        //});
    },
    designRegion_btnOk() {
        this.triggerMethod('dialog:close');

    },
    customSchemaSetting_btnBack_click: function (event) {
        this.app.router.navigate("#customEventEditItem?id=" + this.options.eventId);
        this.app.router.customEventEditItem(this.options.eventId, this.options.scroll, 3, false, false);
    },
    customSchemaSetting_btnDisplay_click: function (event) {
        var self = this;

        /*var tmpSelectedModelSetting = self.app.entities.collections.customModule.where({ EventId: this.model.id, ModuleType: 98 })[0];
        var data = JSON.parse(tmpSelectedModelSetting.attributes.Data);
        var themeCollection = new Entities_Memory_Position.Collection(data[0].Data.ThemeCollection);
        var selectedModel = data[0].Data.ThemeCollectionSelected;
        var themeCollectionModel = themeCollection.where({ id: selectedModel })[0];*/
        

        var customModule = self.app.entities.collections.customModule.where({ EventId: this.options.eventId, ModuleType: 100 })[0];
        var data = JSON.parse(customModule.attributes.Data);
        var customModule_data = new Entities_Memory.Model(data[0].Data);

        //var modelGenerelSetting = new Entities_Memory.Model(data[0].Data.SchemaScreen);

        var tmpModel = new Entities_Empty.Model(data[0].Data.SchemaScreen);

        var schemaScreen = new View_SchemaScreen({ app: this.app, model: tmpModel, parent: self, fontSelect: 1, themeCollectionModel: customModule_data });


        var callback01 = function (options) {
            self.stopListening(schemaScreen, "dialog:btn01clicked", callback01);
            self.stopListening(schemaScreen, "dialog:btn02clicked", callback02);

            customModule_data.attributes.SchemaScreen = schemaScreen.model.toJSON();
            var strJson = JSON.stringify(customModule_data.toJSON());
            customModule.attributes.Data = '[{ "Data" : ' + strJson + '}]';

            this.model = schemaScreen.model;

            customModule.save(customModule.attribute, {
                silent: false,
                wait: true,
                success: function () {
                    var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: self.options.eventId });
                    if (customEvent && customEvent.length > 0) {
                        var render = new View_Render({ collection: customEvent, app: self.app });
                        var message = 'EVENT_REFRESH';
                        render.pushMessage(self.model.id, message);
                    }
                }
            });
        }
        self.listenTo(schemaScreen, "dialog:btn01clicked", callback01);

        var callback02 = function (options) {
            self.stopListening(schemaScreen, "dialog:btn01clicked", callback01);
            self.stopListening(schemaScreen, "dialog:btn02clicked", callback02);
        }
        self.listenTo(schemaScreen, "dialog:btn02clicked", callback02);

        self.app.dialogRegion.show(schemaScreen);
    }
}, Backbone.Radio.Requests);
